export enum ProtectionTargetType {
  ITEM = "Item",
  PET = "Pet",
  PERSON = "Person",
  PROPERTY = "Property",
  VEHICLE = "Vehicle"
}
